import { call, put, takeLatest, takeEvery, all } from 'redux-saga/effects';

import { addAPIError, removeAPIError } from 'redux/apiErrors/sagas';

import {
  //   contactForm,
  contactUsForm,
  subscribeForm,
  //   feedbackForm,
  getForm,
  submitForm
} from './api';
import {
  // CONTACT_FORM_REQUEST,
  CONTACT_US_FORM_REQUEST,
  FORM_OBJECT_REQUESTING,
  RESET_FORM_ISFETCHING,
  SUBSCRIBE_FORM_REQUEST,
  //   FEEDBACK_FORM_REQUEST,
  GET_FORM_REQUEST,
  GET_FORM_SUCCESS,
  SUBMIT_RESPONSE_REQUEST
} from './constants';

function* get(action) {
  try {
    yield call(removeAPIError);
    yield put({ type: FORM_OBJECT_REQUESTING });
    const response = yield call(getForm, action.code);
    yield put({ type: GET_FORM_SUCCESS, payload: response.data });
    return response.data;
  } catch (error) {
    yield put({ type: RESET_FORM_ISFETCHING });
    if (action.onError) {
      action.onError(error);
    } else {
      yield call(addAPIError, error);
    }
    return null;
  }
}

function* submit(action) {
  try {
    yield call(removeAPIError);
    const formResponse = action.response;
    formResponse.channel = 'Web';
    const response = yield call(submitForm, formResponse, action.formId);
    action.onSuccess(response.data);
  } catch (error) {
    action.onError(error);
  }
}

//  function* contact(action) {
//   try {
//     yield call(removeAPIError);
//     yield put({ type: FORM_OBJECT_REQUESTING });
//     const response = yield call(contactForm, action.form);
//     action.onSuccess(response.data);
//   } catch (error) {
//     yield put({ type: RESET_FORM_ISFETCHING });
//     action.onError(error);
//   }
// }

function* contactUs(action) {
  try {
    yield call(removeAPIError);
    yield put({ type: FORM_OBJECT_REQUESTING });
    const response = yield call(contactUsForm, action.data);
    if (action.onSuccess) {
      action.onSuccess(response.data);
    }
  } catch (error) {
    yield put({ type: RESET_FORM_ISFETCHING });
    yield call(addAPIError, error);
    if (action.onError) {
      action.onError(error);
    }
  }
}

function* subscribe(action) {
  try {
    yield call(removeAPIError);
    yield put({ type: FORM_OBJECT_REQUESTING });
    const response = yield call(subscribeForm, action.data);
    action.onSuccess(response.data);
  } catch (error) {
    yield put({ type: RESET_FORM_ISFETCHING });
    action.onError(error);
  }
}

//  function* feedback(action) {
//   try {
//     yield call(removeAPIError);
//     yield put({ type: FORM_OBJECT_REQUESTING });
//     const response = yield call(feedbackForm, action.form);
//     action.onSuccess(response.data);
//   } catch (error) {
//     yield put({ type: RESET_FORM_ISFETCHING });
//     action.onError(error);
//   }
// }

function* watchList() {
  //   yield takeLatest(CONTACT_FORM_REQUEST, contact);
  yield takeLatest(CONTACT_US_FORM_REQUEST, contactUs);
  yield takeLatest(SUBSCRIBE_FORM_REQUEST, subscribe);
  //   yield takeLatest(FEEDBACK_FORM_REQUEST, feedback);
  yield takeEvery(GET_FORM_REQUEST, get);
  yield takeLatest(SUBMIT_RESPONSE_REQUEST, submit);
}

export default function* formsSagas() {
  yield all([watchList()]);
}
